import { cardsItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          精选专题
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsItems.slice(0, 3).map((item) => (
            <article
              key={item.id}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-semibold bg-primary-500 text-background-50 rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardsItems.slice(3).map((item) => (
            <article
              key={item.id}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-secondary-300 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-48 aspect-[4/3] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-semibold bg-secondary-500 text-background-50 rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex-1">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-secondary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}